// extracted by mini-css-extract-plugin
module.exports = {"alertWrapper":"app_alertWrapper__3GpxH","alertSvg":"app_alertSvg__8NEAZ"};